<template>
  <div>
    <!-- SELECT FORMAT -->
    <div class="text-center" v-if="!form.format">
      <p>{{ $t('select_type_creative') }}</p>
      <div class="mt-4 d-flex flex-column align-items-center mb-4">
        <div class="d-flex flex-column flex-lg-row align-items-center">
          <Button
            class="btn btn-color10 mb-3 me-lg-3"
            @click="selectFormat('DISPLAY')"
          >
            {{ $t('creative_format.display') }}
          </Button>
          <Button
            class="btn btn-color10 mb-3 me-lg-3"

            @click="selectFormat('DISPLAY_VIDEO')"
          >
            {{ $t('creative_format.display_video') }}
          </Button>
        </div>
        <div class="d-flex flex-column flex-lg-row align-items-center">
          <Button
            class="btn btn-color10 text-nowrap  mb-3 me-lg-3"
            @click="selectFormat('AUDIO')"
          >
            {{ $t('creative_format.audio') }}
          </Button>
          <Button
            class="btn btn-color10 text-nowrap  mb-3 me-lg-3"
            @click="selectFormat('NATIVE_DISPLAY')"
          >
            {{ $t('creative_format.native_display') }}
          </Button>
          <Button
            class="btn btn-color10 mb-3 me-lg-3"
            @click="selectFormat('PUSH')"
          >
            {{ $t('creative_format.push') }}
          </Button>
        </div>
      </div>
    </div><!-- END SELECT FORMAT -->

    <!-- FORM -->
    <div v-else>
      <div v-for="(creative, index) in form.creatives" :key="index">
        <div :class="{ 'd-flex flex-column flex-lg-row justify-content-lg-center': hasPreview }">

          <form :class="{'col-lg-6': hasPreview }" @submit.prevent="submit" class="text-start default-form">
            <div class="mb-2" v-if="!format && index == 0">
              <a href="#" @click.prevent="restart(false)"><i class="fa fa-angle-left me-2"></i>{{ $t('back') }}</a>
            </div>
            <div>
              <!-- FILE -->
              <div class="form-group mb-3" v-if="form.format !== 'YOUTUBE'">
                <div>
                  <label class="form-label fw-bold">
                    {{ $t('insert_the_creative_first') }}
                    <label v-if="index >= 1"> | N° {{ index + 1 }} </label>
                  </label>
                  <br/>
                </div>
                <input type="file" class="form-control" @change="changeFile($event, index)" :accept="allowedFileTypes" />
                <div
                  class="progress"
                  role="progressbar"
                  aria-label="Animated striped example"
                  :aria-valuenow="uploadProgress"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  :value="uploadProgress"
                  v-if="form.format === 'DISPLAY_VIDEO'"
                >
                  <div
                    class="progress-bar bg-warning progress-bar-striped progress-bar-animated"
                    :style="{ width: uploadProgress + '%' }"
                  >{{ uploadProgress + '%' }}</div>
                </div>
                <p class="font-size-xSmall" v-if="form.format === 'NATIVE_DISPLAY' || form.format === 'PUSH'">{{ $t('images_with_a_maximum_size_of_800kb') }}</p>
                <p class="font-size-xSmall" v-else-if="form.format === 'AUDIO'">{{ $t('audio_max_30_seconds') }}</p>
                <p class="font-size-xSmall text-danger" v-if="form.creatives[index].isAudioFileSizeNotAllowed"><strong>{{ $t('attention') }}:</strong> {{ $t('allowed_audio_duration_30_seconds') }}</p>
                <p class="font-size-xSmall" v-else-if="form.format === 'DISPLAY'">{{ $t('PNG_JPG_or_GIF_with_a_maximum_of_800kb') }}</p>
                <p class="font-size-xSmall" v-else-if="form.format === 'DISPLAY_VIDEO'">{{ $t('MP4_with_a_maximum_of_100MB') }}</p>
                <p class="font-size-xSmall" v-if="form.format !== 'AUDIO'">{{ $t('allowed_dimensions') + allowedLayouts }}</p>
                <p class="font-size-xSmall" v-else-if="form.format === 'PUSH'">{{ $t('creatives_in_jpeg_or_png_format', { width: '1280', height: '720' }) }}</p>
                <template v-if="form.format !== 'AUDIO'">
                  <p class="font-size-xSmall text-danger" v-if="form.creatives[index].fileNotAllowed"><strong>{{ $t('attention') }}:</strong> {{ $t('file_has_dimensions_that_are_not_allowed') }}</p>
                  <p class="font-size-xSmall text-danger" v-if="form.creatives[index].fileDifferentLayout"><strong>{{ $t('attention') }}:</strong> {{ $t('file_cannot_have_different_dimensions') }}</p>
                </template>
                <p class="font-size-xSmall text-danger" v-if="form.creatives[index].fileNotAllowed && form.creatives[index].fileTooLarge"><strong>{{ $t('attention') }}:</strong> {{ $t('file_size_exceeded') }}</p>
              </div>
              <!-- END FILE -->

              <template v-if="form.creatives[index].file || localCreative">
                <!-- NAME -->
                <div class="form-group mb-3">
                  <label class="form-label fw-bold">{{ $t('name') }}</label>
                  <input type="text" class="form-control" :placeholder="$t('name')" v-model.trim="$v.form.creatives.$each.$iter[index].name.$model" />
                  <p class="font-size-xSmall text-end mt-1 mb-0"
                     :class="{
                      'text-red': $v.form.creatives.$each.$iter[index].name.$model.length > 128
                    }"
                  >{{ `${ $v.form.creatives.$each.$iter[index].name.$model.length }/128` }}</p>
                  <p
                    class="font-size-xSmall fw-bold mt-2 error-message-card"
                    v-if="$v.form.creatives.$each.$iter[index].name.$model.length > 128"
                  >
                    {{ $t('name_cannot_contain_more_than_128_characters') }}
                  </p>
                </div> <!-- END NAME -->
                <!-- URL -->
                <div class="form-group mb-3" v-if="form.format === 'YOUTUBE'">
                  <label class="form-label fw-bold">URL do vídeo no YouTube</label>
                  <div class="input-group mb-3">
                    <span class="input-group-text">https://</span>
                    <input type="text" class="form-control" placeholder="www.youtube.com/watch?v=69o-O8WB-NU" v-model.trim="$v.form.creatives.$each.$iter[index].youtube_url.$model" />
                  </div>
                </div> <!-- END URL -->
                <!-- URL -->
                <div class="form-group mb-3">
                  <label class="form-label fw-bold">{{ $t('destination_url') }}</label>
                  <div class="input-group mb-3">
                    <span class="input-group-text">https://</span>
                    <input @keydown.space.prevent type="text" class="form-control" placeholder="url.com.br" v-model.trim="$v.form.creatives.$each.$iter[index].url.$model" />
                  </div>
                </div> <!-- END URL -->
                <div class="d-flex flex-column flex-lg-row" v-if="form.format !== 'AUDIO'">
                  <!-- FORMAT -->
                  <div class="col-12 col-lg-6 form-group mb-3 pe-lg-3">
                    <label class="form-label fw-bold">{{ $t('format') }}</label>
                    <select class="form-control" v-model="$v.form.format.$model" disabled>
                      <option value=""></option>
                      <option :value="format.value" v-for="(format, index) in formatOptions" :key="index">{{ format.label }}</option>
                    </select>
                  </div> <!-- END FORMAT -->
                  <!-- LAYOUT -->
                  <div class="col-12 col-lg-6 form-group mb-3 ps-lg-3" v-if="form.format !== 'YOUTUBE' && (form.format !== 'AUDIO' || form.isNewBanner)">
                    <label class="form-label fw-bold">{{ $t('size') }}</label>
                    <select class="form-control" v-model="$v.form.creatives.$each.$iter[index].layout.$model" disabled>
                      <option value=""></option>
                      <option :value="layout.value" v-for="(layout, index) in layoutOptions" :key="index">{{ layout.label }}</option>
                    </select>
                  </div> <!-- END LAYOUT -->
                </div>
                <!-- AUDIO -->
                <template v-if="form.format === 'AUDIO'">
                  <div class="form-group mb-3">
                    <label class="form-label fw-bold">{{ $t('time') }}</label>
                    <input type="text" class="form-control" v-model="form.creatives[index].durationString" :placeholder="form.creatives[index].durationString" @change="changeFile($event, index)" disabled>
                  </div>
                  <div class="form-group mb-3">
                    <label class="form-label fw-bold">{{ $t('creative') }} Banner</label><br/>
                    <div class="form-check form-switch mb-2">
                      <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="form.creatives[index].isNewBanner" @change="handleBannerToggle">
                      <label class="form-check-label" for="flexSwitchCheckDefault">{{ $t('add_new') }}</label>
                    </div>
                    <template v-if="!form.creatives[index].isNewBanner">
                      <!-- CREATIVES MULTISELECT -->
                      <template v-if="creativesLoader">
                        <Loader
                          :size="'small'"
                          :align="'start'"
                        />
                      </template>
                      <template v-else>
                        <Multiselect
                          v-model="form.creatives[index].companion_creative_id"
                          label="label"
                          track-by="code"
                          :options="creativesOptions"
                          :option-height="150"
                          :placeholder="$t('search_for_a_creative')"
                        >
                          <template slot="singleLabel" slot-scope="props">
                            <img class="option__image" :src="props.option.img" alt="teste">
                            <span class="option__desc"><span class="option__title">{{ props.option.label }}</span></span>
                          </template>
                          <template slot="option" slot-scope="props">
                            <img class="option__image" :src="props.option.img" alt="teste">
                            <div class="option__desc"><span class="option__title">{{ props.option.label }}</span></div>
                          </template>
                        </Multiselect>
                      </template><!-- CREATIVES MULTISELECT -->
                    </template>
                    <template v-else>
                      <input type="file" class="form-control" @change="changeBannerFile($event, index)"  accept="image/*" />
                      <p class="font-size-xSmall" v-if="form.format === 'AUDIO'">{{ $t('allowed_dimensions') }} 301x301 </p>
                      <p class="font-size-xSmall text-danger" v-if="form.creatives[index].fileNotAllowed && form.format === 'AUDIO'"><strong>{{ $t('attention') }}:</strong> {{ $t('file_has_dimensions_that_are_not_allowed') }}</p>
                    </template>
                  </div>
                </template><!-- AUDIO -->
                <template v-if="form.format === 'NATIVE_DISPLAY' || form.format === 'PUSH'">
                  <!-- LOGO -->
                  <div class="form-group mb-3">
                    <label class="form-label fw-bold">{{ $t('logo') }}</label><br/>
                    <input type="file" @change="changeLogoFile($event, index)" accept="image/*" />
                    <p class="font-size-xSmall">{{ $t('images_with_a_maximum_size_of_800kb') }}</p>
                    <p class="font-size-xSmall">{{ $t('allowed_sizes_200x200') }}</p>
                    <p class="font-size-xSmall text-danger" v-if="form.creatives[index].logoFileNotAllowed"><strong>{{ $t('attention') }}:</strong> {{ $t('file_has_a_size_that_is_not_allowed') }}</p>
                  </div> <!-- END LOGO -->
                  <!-- ADVERTISER DISPLAY NAME -->
                  <div class="form-group">
                    <label class="form-label fw-bold">{{ $t('advertisers_display_name') }}</label>
                    <input type="text" class="form-control" :placeholder="$t('title')" v-model.trim="$v.form.creatives.$each.$iter[index].advertiser_display_name.$model" />
                    <p class="font-size-xSmall text-end mt-1 mb-0"
                       :class="{
                        'text-red': form.creatives[index].advertiser_display_name.length > 25
                      }"
                    >{{ `${ form.creatives[index].advertiser_display_name.length }/25` }}</p>
                    <p
                      class="font-size-xSmall fw-bold mt-2 error-message-card"
                      v-if="form.creatives[index].advertiser_display_name.length > 25"
                    >
                      {{ $t('advertiser_display_name_cannot_contain_more_than_25_characters') }}
                    </p>
                  </div> <!-- END ADVERTISER DISPLAY NAME -->
                  <!-- HEADLINE -->
                  <div class="form-group">
                    <label class="form-label fw-bold">{{ $t('title') }}</label>
                    <input type="text" class="form-control" :placeholder="$t('title')" v-model.trim="$v.form.creatives.$each.$iter[index].headline.$model" />
                    <p class="font-size-xSmall text-end mt-1 mb-0"
                       :class="{
                        'text-red': form.creatives[index].headline.length > 25
                      }"
                    >{{ `${ form.creatives[index].headline.length }/25` }}</p>
                    <p
                      class="font-size-xSmall fw-bold mt-2 error-message-card"
                      v-if="form.creatives[index].headline.length > 25"
                    >
                      {{ $t('title_cannot_contain_more_than_25_characters') }}
                    </p>
                  </div> <!-- END HEADLINE -->
                  <!-- BODY TEXT -->
                  <div class="form-group">
                    <label class="form-label fw-bold">{{ $t('body_text') }}</label>
                    <input type="text" class="form-control" placeholder="Corpo" v-model.trim="$v.form.creatives.$each.$iter[index].body_text.$model" />
                    <p class="font-size-xSmall text-end mt-1 mb-0"
                       :class="{
                        'text-red': form.creatives[index].body_text.length > bodyTextMaxLength
                      }"
                    >{{ `${ form.creatives[index].body_text.length }/${ bodyTextMaxLength }` }}</p>
                    <p
                      class="font-size-xSmall fw-bold mt-2 error-message-card"
                      v-if="form.creatives[index].body_text.length > bodyTextMaxLength"
                    >
                      {{ $t('body_text_cannot_contain_more_than_characters', {value: bodyTextMaxLength}) }}
                    </p>
                  </div> <!-- END BODY TEXT -->
                  <!-- CTA -->
                  <div class="form-group">
                    <label class="form-label fw-bold">
                      {{ $t('call_to_action') }}
                      <span
                        id="cta-tooltip"
                      >
                        <i class="fa fa-info-circle font-size-regular"></i>
                      </span>
                    </label>
                    <b-tooltip target="cta-tooltip">
                      <strong>{{ $t('examples') }}</strong><br/>
                      {{ $t('click_here') }}<br/>
                      {{ $t('learn_more') }}<br/>
                      {{ $t('contact_us2') }}
                    </b-tooltip>
                    <input type="text" class="form-control" :placeholder="$t('learn_more')" v-model.trim="$v.form.creatives.$each.$iter[index].call_to_action.$model" />
                    <p class="font-size-xSmall text-end mt-1 mb-0"
                       :class="{
                        'text-red': form.creatives[index].call_to_action.length > 15
                      }"
                    >{{ `${ form.creatives[index].call_to_action.length }/15` }}</p>
                    <p
                      class="font-size-xSmall fw-bold mt-2 error-message-card"
                      v-if="form.creatives[index].call_to_action.length > 15"
                    >
                      {{ $t('call_to_action_cannot_contain_more_than_15_characters') }}
                    </p>
                  </div> <!-- END CTA  -->
                  <!-- CAPTION URL -->
                  <div class="form-group">
                    <label class="form-label fw-bold">
                      {{ $t('caption_url') }}
                      <span
                        id="cta-caption-url"
                      >
                        <i class="fa fa-info-circle font-size-regular"></i>
                      </span>
                    </label>
                    <b-tooltip target="cta-caption-url">
                      {{ $t('recommend_friendly_version_of_the_landing_page_URL') }}
                    </b-tooltip>
                    <input type="text" class="form-control" placeholder="Saiba mais" v-model.trim="$v.form.creatives.$each.$iter[index].caption_url.$model" />
                    <p class="font-size-xSmall text-end mt-1 mb-0"
                       :class="{
                        'text-red': form.creatives[index].caption_url.length > 30
                      }"
                    >{{ `${ form.creatives[index].caption_url.length }/30` }}</p>
                    <p
                      class="font-size-xSmall fw-bold mt-2 error-message-card"
                      v-if="form.creatives[index].caption_url.length > 30"
                    >
                      {{ $t('display_URL_cannot_be_longer_than_30_characters') }}
                    </p>
                  </div> <!-- END CAPTION URL  -->
                </template>
                <!-- AVAILABILITY -->
                <div class="form-group mb-3" v-if="1 == 2">
                  <label class="form-label fw-bold">{{ $t('availability') }}</label><br/>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="av-desktop" v-model="form.creatives[index].is_desktop">
                    <label class="form-check-label" for="av-desktop">{{ $t('desktop') }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="av-mobile" v-model="form.creatives[index].is_mobile">
                    <label class="form-check-label" for="av-mobile">{{ $t('mobile') }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="av-app" v-model="form.creatives[index].is_app">
                    <label class="form-check-label" for="av-app">{{ $t('apps') }}</label>
                  </div>
                </div> <!-- END AVAILABILITY -->

                <!--begin:spacing-->
                <div v-if="form.creatives.length > 1"><hr><br></div>
                <!-- end:spacing-->

              </template>
            </div>
        </form>

        <!-- PREVIEW -->
        <div class="col-lg-6 text-start px-5  mt-5" v-if="hasPreview">
          <h3 class="highlighted-color1 mb-4">
            <span>{{ $t('preview') }}</span>
          </h3>
          <CreativePreviewWrapper
            :advertiser="advertiser"
            :form="form"
            :creative="localCreative"
            :index="index"
            :isForm="true"
          />
        </div> <!-- END PREVIEW -->
      </div>
      <template v-if="!localCreative && 1 == 2">
        <Button
          v-if="!isCampaignCreationPage && form.creatives.length === 1 || (index !== 0 && index + 1 === form.creatives.length) "
          type="button"
          class="btn btn-sm btn-color10 me-3 mt-5"
          @click="toggleCreative(true)"
          :loading="loader"
        >
          {{ $t('include_more_creatives') }}
        </Button>
        <Button
          v-if="!isCampaignCreationPage && form.creatives.length > 1 && index !== 0 && form.creatives.length === index + 1"
          type="button"
          class="btn btn-sm btn-color10 me-3 mt-5"
          @click="toggleCreative(false)"
          :loading="loader"
        >
          {{ $t('remove_creative') }}
        </Button>
      </template>

      </div>
      <!-- ACTIONS -->
      <div class="text-center mt-3">
        <!-- MESSAGES -->
        <div
          class="mb-2 alert-message-card text-color2 font-size-small px-3 py-2"
          v-if="loader"
        >
          <p
            class="mb-0"
          >
            {{ $t('this_action_may_take_a_few_minutes') }}
          </p>
        </div> <!-- END MESSAGES -->
        <div class="text-center">
          <Button
            type="button"
            class="btn btn-color9 me-3"
            @click="submit"
            :loading="loader"
            :disabled="!isFormComplete"
          >
            {{ creative ? $t('edit') : $t('create') }}
          </Button>
          <Button
            type="button"
            class="btn btn-color9"
            @click="$emit('canceled')"
            v-if="creative || showCancel"
          >
            {{ $t('cancel') }}
          </Button>
        </div>
      </div> <!-- END ACTIONS -->
    </div> <!-- END FORM -->
  </div>
</template>

<script>

import AdvertisersService from '@/modules/advertisers/services/advertisers-service'
import CreativesService from '@/modules/creatives/services/creatives-service'
import { required, maxLength } from 'vuelidate/lib/validators'
import Loader from '@/components/common/Loader/Loader'
import Multiselect from 'vue-multiselect'
import { parseErrorResponseToArray } from '@/utils'

import { CREATIVE_FORMAT_OPTIONS, CREATIVE_LAYOUT_OPTIONS } from '@/modules/helpers/constants/creative-options'

import Button from '@/components/common/Button/Button'
import CreativePreviewWrapper from '@/components/creatives/CreativePreview/CreativePreviewWrapper'

export default {
  name: 'UpsertCreativeForm',
  props: ['advertiserId', 'creative', 'format', 'hidePreview', 'showCancel'],
  components: {
    Button,
    CreativePreviewWrapper,
    Loader,
    Multiselect
  },
  data () {
    return {
      advertiser: '',
      creatives: [],
      creativesLoader: false,
      loader: false,
      localCreative: null,
      form: {
        advertiser_id: '',
        format: '',
        creatives: [
          {
            name: '',
            fileType: '',
            layout: '',
            url: '',
            isAudioFileSizeNotAllowed: false,
            is_desktop: true,
            is_mobile: true,
            is_app: true,
            file: null,
            logo: null,
            banner: null,
            companion_creative_id: [],
            headline: '',
            body_text: '',
            call_to_action: '',
            advertiser_display_name: '',
            caption_url: '',
            youtube_url: '',
            fileNotAllowed: false,
            logoFileNotAllowed: false,
            fileDifferentLayout: false,
            isNewBanner: false,
            duration: '',
            durationString: '',
            fileTooLarge: false,
            total_chunks: 0
          }
        ]
      },
      uploadProgress: 0
    }
  },
  watch: {
    creative () {
      this.setCreative()
    }
  },
  async created () {
    this.form.advertiser_id = this.advertiserId
    this.localCreative = this.creative
    if (this.format) this.form.format = this.format

    await this.getCreatives()
    this.setCreative()
    await this.getAdvertiser()
  },
  validations () {
    //  Regex rule to avoid spaces in URL
    const noSpaces = value => /^\S+$/.test(value)

    const baseValidations = {
      form: {
        format: { required },
        advertiser_id: { required },
        creatives: {
          $each: {
            name: { required, maxLength: maxLength(128) },
            url: { required, noSpaces }
            // fileType removido, pois é definido automaticamente no changeFile
          }
        }
      }
    }
    // File is required when it's not edit
    if (!this.creative) baseValidations.form.creatives.$each.file = { required }

    const validations = baseValidations.form.creatives.$each

    if (this.form.format !== 'YOUTUBE') {
      validations.layout = { required }
    }

    if (this.form.format === 'NATIVE_DISPLAY' || this.form.format === 'PUSH') {
      validations.advertiser_display_name = { required, maxLength: maxLength(25) }
      validations.headline = { required, maxLength: maxLength(25) }
      validations.body_text = { required, maxLength: maxLength(75) }
      validations.call_to_action = { required, maxLength: maxLength(15) }
      validations.caption_url = { required, maxLength: maxLength(30) }
    } else if (this.form.format === 'YOUTUBE') {
      validations.youtube_url = { required }
    } else if (this.form.format === 'AUDIO') {
      validations.duration = { required }
    }

    if (this.form.format === 'PUSH') {
      validations.body_text = { required, maxLength: maxLength(40) }
    }

    if (!this.creative && (this.form.format === 'NATIVE_DISPLAY' || this.form.format === 'PUSH')) validations.logo = { required } // Logo agora obrigatório

    return baseValidations
  },
  computed: {
    //  Check file size
    allowedFileSize () {
      let allowedFileSize
      if (this.form.format === 'DISPLAY_VIDEO') allowedFileSize = 100000000
      if (['DISPLAY', 'NATIVE_DISPLAY', 'PUSH'].includes(this.form.format)) allowedFileSize = 800000
      return allowedFileSize
    },
    /*
     * Check type file
     */
    allowedFileTypes () {
      if (this.form.format === 'NATIVE_DISPLAY' || this.form.format === 'DISPLAY' || this.form.format === 'PUSH') return 'image/*'
      else if (this.form.format === 'DISPLAY_VIDEO') return 'video/*'
      else if (this.form.format === 'AUDIO') return 'audio/*'
      return ''
    },
    /**
     * Allowed layouts
     */
    allowedLayouts () {
      const filtered = this.layoutOptions.filter(item => {
        return item.format === this.form.format
      })
      const sizes = filtered.map(item => {
        return item.label
      })
      return sizes.join(', ')
    },
    /**
     * Body text max length
     */
    bodyTextMaxLength () {
      if (this.form.format === 'NATIVE_DISPLAY') return 75
      else if (this.form.format === 'PUSH') return 40
      return 0
    },
    creativesOptions () {
      return this.creatives.map(creative => {
        return {
          label: creative.name,
          code: creative.id,
          img: creative.file
        }
      })
    },
    /**
     * Get content type (image or video) of creative
     */
    contentType () {
      if (!this.form.format) return
      if (this.form.format === 'NATIVE_DISPLAY' || this.form.format === 'DISPLAY' || this.form.format === 'PUSH') return 'IMAGE'
      else if (this.form.format === 'DISPLAY_VIDEO') return 'VIDEO'
      else if (this.form.format === 'AUDIO') return 'AUDIO'
      return ''
    },
    /**
     * All available creative formats
     */
    formatOptions () {
      return CREATIVE_FORMAT_OPTIONS
    },
    /**
     * Check if form has preview
     */
    hasPreview () {
      return (this.form.format === 'NATIVE_DISPLAY' || this.form.format === 'PUSH') && !this.hidePreview
    },
    isCampaignCreationPage () {
      return this.$route.name.includes('campaigns')
    },
    /**
     * Is form complete
     */
    isFormComplete () {
      if (this.form.format === 'DISPLAY_VIDEO') {
        //  Only validate upload progress when creating a new creative
        if (!this.creative) return !this.$v.$invalid && this.uploadProgress === 100
      }
      return !this.$v.$invalid
    },
    /**
     * All available creative layouts
     */
    layoutOptions () {
      return CREATIVE_LAYOUT_OPTIONS
    }
  },
  methods: {
    /**
     * Handle change file
     */
    async changeFile (e, index) {
      const file = e.target.files[0]
      if (!file) return
      let element = null
      if (this.form.format === 'NATIVE_DISPLAY' || this.form.format === 'DISPLAY' || this.form.format === 'PUSH') {
        element = new Image()
        element.src = URL.createObjectURL(file)
        element.onload = () => {
          this.validateFileDimension(file, element, index)
        }
      } else if (this.form.format === 'DISPLAY_VIDEO') {
        if (
          file.type !== 'video/mp4' ||
          !file.name.toLowerCase().endsWith('.mp4') ||
          file.size > 100 * 1024 * 1024
        ) {
          this.$emit('upsert-creative-error', {
            errors: [this.$t('error_validation_video')]
          })
          return
        }
        // Creates a new video element in the HTML document
        element = document.createElement('video')
        // Sets the video source as an object URL created from the 'file' object
        element.src = URL.createObjectURL(file)
        // Create callback
        element.onloadedmetadata = () => {
          this.validateFileDimension(file, element, index)

          if (!this.form.creatives[index].fileNotAllowed && !this.form.creatives[index].fileDifferentLayout) {
            this.uploadProgress = 0
            this.form.creatives[index].file = null
            this.handleFileVideo(file, index)
          }
        }
      } else if (this.form.format === 'AUDIO') {
        element = document.createElement('audio')
        element.src = URL.createObjectURL(file)
        element.onloadedmetadata = () => {
          this.validateAudioFileSize(file, element, index)
        }
        this.form.creatives[index].layout = '300x250'
      }
    },
    /**
     * Handle change logo file
     */
    changeLogoFile (e, index) {
      const file = e.target.files[0]

      // Validate if the file is in allowed layout
      const image = new Image()
      image.src = URL.createObjectURL(file)
      image.onload = () => {
        if (image.width === 200 && image.height === 200) {
          this.form.creatives[index].logoFileNotAllowed = false
          this.form.creatives[index].logo = file
        } else {
          this.form.creatives[index].logoFileNotAllowed = true
          this.form.creatives[index].logo = null
        }
      }
    },
    /**
     * Handle change logo file
     */
    changeBannerFile (e, index) {
      const file = e.target.files[0]
      let element = null
      element = new Image()
      element.src = URL.createObjectURL(file)
      this.form.creatives[index].layout = '300x250'
      element.onload = () => {
        this.validateFileDimension(file, element, index)
      }
    },
    /**
     * delay
     */
    delay (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    /**
     * Get advertiser
     */
    async getAdvertiser () {
      try {
        const advertiser = await AdvertisersService.getAdvertiser(this.advertiserId)
        this.advertiser = advertiser
        if (!this.creative) {
          this.form.creatives.map(creative => {
            creative.advertiser_display_name = advertiser.name
          })
        }
      } catch (error) {

      }
    },
    /**
     * Get creatives - banner Audio
     */
    async getCreatives () {
      this.creativesLoader = true
      try {
        const creatives = await CreativesService.getCreatives({
          advertiserId: this.advertiserId,
          format: 'DISPLAY',
          page: this.page,
          layout: '301x301',
          approved_status: this.format === 'YOUTUBE' ? 'PENDING_CREATION' : ''
        })

        if (this.page === 1) {
          this.creatives = creatives.data
        } else {
          this.creatives = [...this.creatives, ...creatives.data]
        }

        this.isLoadMoreVisible = creatives.meta.current_page !== creatives.meta.last_page
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.creativesLoader = false
    },
    /**
     * handle banner toggle
     */
    handleBannerToggle (event) {
      this.form.isNewBanner = event.target.checked
      // Reset related fields when toggling
      if (this.form.isNewBanner) {
        this.form.companion_creative_id = null
      } else {
        this.form.banner = null
      }
    },
    /*
     * handle file video
     */
    async handleFileVideo (file, index) {
      this.uploadProgress = 0
      const CHUNK_SIZE = 1024 * 1024 // 1MB
      const totalChunks = Math.ceil(file.size / CHUNK_SIZE)
      const fileId = `${file.name}-${Date.now()}_${Math.random().toString(36).substring(2, 9)}`
      this.form.creatives[index].total_chunks = totalChunks

      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        const start = chunkIndex * CHUNK_SIZE
        const end = Math.min(file.size, start + CHUNK_SIZE)
        const chunk = file.slice(start, end)

        try {
          await this.uploadVideoWithRetry({
            chunk: chunk,
            fileId: fileId,
            chunkIndex: chunkIndex,
            totalChunks: totalChunks,
            fileName: file.name
          })
        } catch (error) {
          this.$emit('upsert-creative-error', error)
          return
        }

        this.uploadProgress = Math.round(((chunkIndex + 1) / totalChunks) * 100)
        await this.delay(1000)
      }
      this.form.creatives[index].file = fileId
    },
    /**
     * Restart form
     */
    restart (partialReset = false) {
      if (this.form.creatives.length > 1) {
        this.form.creatives.splice(1) // Remove todos a partir do index 1
      }
      this.form.duration = null
      this.form.banner = null
      this.form.creatives[0].name = ''
      this.form.creatives[0].layout = ''
      this.form.creatives[0].url = ''
      this.form.creatives[0].is_desktop = false
      this.form.creatives[0].is_mobile = false
      this.form.creatives[0].is_app = false
      this.form.creatives[0].file = null
      this.form.creatives[0].logo = null
      this.form.creatives[0].headline = ''
      this.form.creatives[0].body_text = ''
      this.form.creatives[0].call_to_action = ''
      this.form.creatives[0].advertiser_display_name = ''
      this.form.creatives[0].caption_url = ''
      if (!partialReset) this.selectFormat('')
    },
    /**
     * Select creative format
     */
    selectFormat (format) {
      this.form.format = format
      this.$emit('format-selected', format)
    },
    setCreative () {
      if (this.creative) {
        this.form.creatives[0].name = this.creative.name
        this.form.format = this.creative.format
        this.form.creatives[0].layout = this.creative.layout
        this.form.creatives[0].url = this.creative.url.replace('https://', '').replace('http://', '')
        this.form.creatives[0].is_app = this.creative.is_app
        this.form.creatives[0].is_desktop = this.creative.is_desktop
        this.form.creatives[0].is_mobile = this.creative.is_mobile
        this.form.creatives[0].headline = this.creative.headline
        this.form.creatives[0].body_text = this.creative.body_text
        this.form.creatives[0].call_to_action = this.creative.call_to_action
        this.form.creatives[0].advertiser_display_name = this.creative.advertiser_display_name ? this.creative.advertiser_display_name : ''
        this.form.creatives[0].caption_url = this.creative.caption_url ? this.creative.caption_url : ''

        if (this.format === 'AUDIO') {
          const cc = this.creative.companion_creative
          this.form.creatives[0].companion_creative_id = {
            label: cc.name,
            code: cc.id,
            img: cc.file
          }
        }
      }
    },
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      try {
        const form = Object.assign({}, this.form)

        if (form.caption_url) form.caption_url = form.caption_url.replace('https://', '').replace('http://', '')
        if (form.format === 'YOUTUBE') {
          form.youtube_url = `https://${form.youtube_url.replace('https://', '').replace('http://', '')}`
        }

        form.creatives = form.creatives.map(creative => {
          // Ajusta URLs
          const adjustedCreative = {
            ...creative,
            url: creative.url ? `https://${creative.url.replace('https://', '').replace('http://', '')}` : '',
            caption_url: creative.caption_url ? creative.caption_url.replace('https://', '').replace('http://', '') : '',
            youtube_url: creative.youtube_url ? `https://${creative.youtube_url.replace('https://', '').replace('http://', '')}` : '',
            companion_creative_id: creative.companion_creative_id.code
          }

          // Limpa campos para DISPLAY, DISPLAY_VIDEO e AUDIO
          if (form.format === 'DISPLAY' || form.format === 'DISPLAY_VIDEO' || form.format === 'AUDIO') {
            adjustedCreative.logo = null
            adjustedCreative.headline = ''
            adjustedCreative.body_text = ''
            adjustedCreative.call_to_action = ''
            adjustedCreative.advertiser_display_name = ''
            adjustedCreative.caption_url = ''
          }
          return adjustedCreative
        })

        let creative
        if (this.creative) {
          creative = await CreativesService.updateCreative(this.creative.id, form)
          this.$emit('creative-updated', creative)
        } else {
          await CreativesService.createCreative(form)
          this.$emit('creative-created')
          if (this.format) this.restart(true)
        }
      } catch (error) {
        this.$emit('upsert-creative-error', error)
      }
      this.loader = false
    },
    /**
     * Validate file size audio
     */
    validateAudioFileSize (file, element, index) {
      this.form.creatives[index].durationString = element.duration.toFixed(0) + this.$t('seconds')
      this.form.creatives[index].duration = element.duration.toFixed(0)
      if (element.duration.toFixed(0) > 30) {
        this.form.creatives[index].isAudioFileSizeNotAllowed = true
        this.form.creatives[index].file = null
        return
      }

      this.form.creatives[index].isAudioFileSizeNotAllowed = false
      this.form.creatives[index].file = file
    },
    /*
     * Add or remove creative
     */
    toggleCreative (insert) {
      if (insert) {
        this.form.creatives.push({
          name: '',
          fileType: '',
          layout: '',
          url: '',
          is_desktop: true,
          is_mobile: true,
          is_app: true,
          file: null,
          logo: null,
          headline: '',
          body_text: '',
          call_to_action: '',
          advertiser_display_name: '',
          caption_url: '',
          youtube_url: ''
        })
      } else {
        this.form.creatives.pop()
      }
    },
    /**
     * upload video with retry
     */
    async uploadVideoWithRetry (params, retries = 3, delayMs = 1000) {
      for (let attempt = 0; attempt < retries; attempt++) {
        try {
          await CreativesService.uploadFileChunk(params)
          return // Sucesso, sai da função
        } catch (error) {
          if (error.response?.status === 429 && attempt < retries - 1) {
            console.warn(`429 recebido. Tentando novamente em ${delayMs}ms...`)
            await this.delay(delayMs)
            delayMs *= 2 // Backoff exponencial
          } else {
            throw error // Se não for 429 ou se acabou as tentativas
          }
        }
      }
    },
    /**
     * Validate file dimension
     */
    validateFileDimension (file, element, index = 0) {
      //  Validate file size first
      if (file.size > this.allowedFileSize) {
        this.form.creatives[index].fileNotAllowed = true
        this.form.creatives[index].fileTooLarge = true
        return
      }

      // If creative exists, check if element is different layout
      this.form.creatives[index].fileDifferentLayout = false
      const elementWidth = this.contentType === 'IMAGE' || this.contentType === 'AUDIO' ? element.width : element.videoWidth
      const elementHeight = this.contentType === 'IMAGE' || this.contentType === 'AUDIO' ? element.height : element.videoHeight
      if (this.creative) {
        const dimensions = this.form.creatives[index].layout.split('x')
        if (elementWidth !== parseInt(dimensions[0]) || elementHeight !== parseInt(dimensions[1])) {
          this.form.creatives[index].fileDifferentLayout = true
          this.form.creatives[index].file = null
          return
        }
      }
      let allowed = false
      const filtered = this.layoutOptions.filter(item => {
        return item.format === this.form.format
      })
      filtered.forEach(item => {
        if (elementWidth === item.width && elementHeight === item.height) {
          allowed = true
          this.form.creatives[index].layout = item.value
          this.form.layout = item.value
          this.form.format = item.format
        }
      })
      if (allowed) {
        if (this.contentType === 'AUDIO') {
          this.form.creatives[index].banner = file
        } else {
          this.form.creatives[index].file = file
        }
        this.form.creatives[index].fileNotAllowed = false
        // Updates the form name with the file name (without the extension)
        if (!this.form.creatives[index].name) this.form.creatives[index].name = file.name.split('.').slice(0, -1).join('.')
      } else {
        this.form.creatives[index].fileNotAllowed = true
        if (this.contentType !== 'AUDIO') this.form.creatives[index].file = null
        this.form.creatives[index].banner = null
      }
    }
  }
}
</script>

<style lang="css" src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
  .multiselect__option {
      display: block;
      padding: 12px;
      min-height: 40px;
      line-height: 16px;
      text-decoration: none;
      text-transform: none;
      position: relative;
      cursor: pointer;
      white-space: nowrap;
  }

  .option__image {
      max-height: 100px;
      margin-right: 10px;
  }

  .option__desc,.option__image {
      display: inline-block;
      vertical-align: middle;
  }
  .progress {
    margin: 5px 0;
    width: 100%;
    height: 15px;
  }

</style>
